import { render, staticRenderFns } from "./PageCategories.vue?vue&type=template&id=1ddb519a&"
import script from "./PageCategories.vue?vue&type=script&lang=js&"
export * from "./PageCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports